import { createSlice } from "@reduxjs/toolkit";


const preformatJobs = (jobContent) => {
  const newContent = [];
  let childrenIndex = 0;
  let parentIndex = 0;

  const indexJobMap = jobContent.reduce((a, job) => {
    if (job.worktemplate_wf === 0) {
      newContent.push({
        jobId: job.job_id,
        name: `${job.job_id} - ${job.name}`,
        type:  (job.type_template === 'SI' ? 'jobList.components.table.tags.template' : 'jobList.components.table.tags.workflow'),
        templateType: job.type_template,
        status: job.status,
        children: []
      });
      parentIndex += 1;
      return { ...a, [job.job_id]: { parentIndex, childrenIndex: -1 }};
    } else return {};
  }, {});

  for (let i = jobContent.length - 1; i > 0; i--) {
    const job = jobContent[i];

    if (job.worktemplate_wf === 0) childrenIndex = 0;
    else if (indexJobMap?.[job.worktemplate_wf]) {
      indexJobMap[job.job_id] = { parentIndex: indexJobMap[job.worktemplate_wf].parentIndex, childrenIndex };
      newContent[parentIndex-1].children.push({
        jobId: job.job_id,
        name: `${job.job_id} - ${job.name}`,
        type:  (job.type_template === 'SI' ? 'jobList.components.table.tags.template' : 'jobList.components.table.tags.workflow'),
        status: job.status,
        parent: job.worktemplate_wf
      });
      childrenIndex += 1;
    }
  }

  return newContent;
}

const orderById = (array, idKey) => array.sort((a, b) => a[idKey] - b[idKey]);

const formatContent = (currentContent, serviceListType) => {

  switch (serviceListType) {
    case 'documents':
      return [
        ...currentContent.list_files.map((i) => ({ value: i, label: i })),
      ];
    case 'dataModels':
      return [
        ...currentContent.list_files.map((i) => ({ value: i, label: i })),
      ];
    case 'roles':
      return [
        ...currentContent.map((i) => ({ id: i.roleId, label: i.roleName, text: i.roleDescription })),
      ];
    case 'jobs':
      return preformatJobs(currentContent);

    case 'credentials':
      return orderById(currentContent, 'credential_id');

    case 'inventories':
      //TODO: DELETE THIS PLEASE >:l
      const oldVersionApi = JSON.parse(process.env.REACT_APP_OLD_VERSION_API || false) || false;

      if (oldVersionApi) return [ ...currentContent.list_files.map((i) => ({ value: i, label: i })) ];
      else return currentContent;

    default:
      return currentContent;
  }
}

const initialState = {
  content: null,
  error: null,
  success: null,
  isLoaded: true
};

const listSlice = createSlice({
  name: "list",
  initialState,
  reducers: {

    getContentSuccess(state, action) {
      return {...state, isLoaded: false, success: true, content: action.payload};
    },

    getContentRequest(state, action) { return { ...state, isLoaded: true }; },

    getContentFailure(state, action) { return { ...state, isLoaded: false, error: action.payload.message }; },

    cleanUpList(state) {
      return {
        content: null,
        success: null,
        error: null,
        isLoaded: null
      };
    },

    cleanUpMessageList(state) {
      return {
        ...state,
        success: null,
        error: null,
        isLoaded: null
      };
    }
  }
});

const {
  getContentSuccess,
  getContentRequest,
  getContentFailure,
  cleanUpMessageList,
  cleanUpList
} = listSlice.actions;


const fetchGetContentList = (setUpGetContentService, query, serviceListType ) => {
  return (dispatch) => {
    dispatch(getContentRequest());
    setUpGetContentService(query)
    .then(response => dispatch(getContentSuccess(formatContent(response.data, serviceListType))))
    .catch(err => dispatch(getContentFailure(err)))
  }
}


export {
  fetchGetContentList,
  cleanUpMessageList,
  cleanUpList
};

export default listSlice.reducer;
